export enum AircraftImageTypeEnum {
  INTERIOR = 1,
  EXTERIOR = 2,
  FLOORPLAN = 3,
}
